import script from "./loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./loading.vue?vue&type=script&lang=ts&setup=true"

import "./loading.vue?vue&type=style&index=0&id=3eb7eab9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb7eab9"]])

export default __exports__